__webpack_require__.p = "https://microsites.99static.com/marketing-sandbox/_next/";